import { inject as p, ref as v, getCurrentInstance as f, computed as m, onMounted as I, watch as y, toRef as h, onUnmounted as w } from "vue";
import { useId as F } from "./index640.js";
import { formContextKey as L, formItemContextKey as E } from "./index574.js";
const B = () => {
  const l = p(L, void 0), u = p(E, void 0);
  return {
    form: l,
    formItem: u
  };
}, R = (l, {
  formItemContext: u,
  disableIdGeneration: i,
  disableIdManagement: r
}) => {
  i || (i = v(!1)), r || (r = v(!1));
  const a = f(), c = () => {
    let e = a?.parent;
    for (; e; ) {
      if (e.type.name === "ElFormItem")
        return !1;
      if (e.type.name === "ElLabelWrap")
        return !0;
      e = e.parent;
    }
    return !1;
  }, n = v();
  let o;
  const s = m(() => {
    var e;
    return !!(!(l.label || l.ariaLabel) && u && u.inputIds && ((e = u.inputIds) == null ? void 0 : e.length) <= 1);
  });
  return I(() => {
    o = y(
      [h(l, "id"), i],
      ([e, d]) => {
        const t = e ?? (d ? void 0 : F().value);
        t !== n.value && (u?.removeInputId && !c() && (n.value && u.removeInputId(n.value), !r?.value && !d && t && u.addInputId(t)), n.value = t);
      },
      { immediate: !0 }
    );
  }), w(() => {
    o && o(), u?.removeInputId && n.value && u.removeInputId(n.value);
  }), {
    isLabeledByFormItem: s,
    inputId: n
  };
};
export {
  B as useFormItem,
  R as useFormItemInputId
};
